import { CreateTableState, List } from 'gu-ui-kit'
import isEqual from 'lodash/isEqual'
import omit from 'lodash/omit'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import styles from 'modules/Statistics/subcomponents/Layout/Table/statistics-table.module.scss'
import GridSpinner from 'components/UI/GridSpinner'
import ShowMoreButton from 'components/ShowMoreButton'

const LIMIT = 50

const TableComponent = ({
  table,
  tableConfig,
  filters,
  dropTableData = () => {},
  groupBy,
  onTableParamsUpdate = () => {},
  isDemoMode,
  EmptyResults = null,
}) => {
  const [page, setPage] = useState(1)
  const [filtersState, setFiltersState] = useState(
    omit(filters, ['include_vat', 'date_group_period']),
  )

  useEffect(() => {
    dropTableData()
    setPage(1)
  }, [filtersState, groupBy, isDemoMode])

  useEffect(() => {
    onTableParamsUpdate({
      group_by: groupBy,
      limit: LIMIT,
      offset: (page - 1) * LIMIT,
    })
  }, [page, isDemoMode, groupBy, filtersState])

  useEffect(() => {
    const omittedFilters = omit(filters, ['include_vat', 'date_group_period'])
    !isEqual(filtersState, omittedFilters) && setFiltersState(omittedFilters)
  }, [filters])

  const changePage = useCallback((val) => setPage(page + val), [page])

  const tableState = CreateTableState(tableConfig, table.data)

  return !table.loading && table.data.length === 0 ? (
    EmptyResults ? (
      <EmptyResults />
    ) : null
  ) : (
    <div style={{ overflow: 'hidden', width: '100%' }}>
      <div className={styles['table-container']}>
        <List
          Loader={() => <GridSpinner />}
          loading={table.loading}
          table={tableState}
          config={tableConfig}
        />
      </div>

      <ShowMoreButton
        onClick={() => changePage(1)}
        loading={table.loading}
        current={table.data?.length}
        total={table.pagination?.total}
      />
    </div>
  )
}

TableComponent.propTypes = {
  table: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    data: PropTypes.array.isRequired,
    summary: PropTypes.object,
    pagination: PropTypes.shape({
      total: PropTypes.number,
    }),
  }).isRequired,
  tableConfig: PropTypes.object.isRequired,
  filters: PropTypes.object.isRequired,
  dropTableData: PropTypes.func,
  onTableParamsUpdate: PropTypes.func,
  groupBy: PropTypes.string,
  isDemoMode: PropTypes.bool,
  EmptyButton: PropTypes.node,
  new: PropTypes.bool,
  EmptyResults: PropTypes.elementType,
}

export default TableComponent
